import { useCallback, useState } from 'react'

import { patch } from '@/services/delivery/patch'

export const useDeliveryPatch = () => {
  const [isLoading, setIsLoading] = useState(false)

  const deliveryPatch = useCallback(
    async ({
      agrupamentoId,
      alteradoPor,
      comprovanteDeEntrega,
      dataDaEntrega,
      recebidoPor
    }: {
      agrupamentoId: string
      alteradoPor: string
      comprovanteDeEntrega: File
      dataDaEntrega: string
      recebidoPor: string
    }) => {
      try {
        setIsLoading(true)
        const response = await patch({
          agrupamentoId,
          alteradoPor,
          comprovanteDeEntrega,
          dataDaEntrega,
          recebidoPor
        })
        return response
      } catch (error) {
        return error
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { deliveryPatch, isLoading }
}
